require('./modifyLimitErrorStep.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const { useEffect } = React;
const classNames = require('classnames');
// @ commons
const { FormattedText, formatText } = require('core/i18n').i18n;
const WizardError = require('components/commons/wizardError/wizardError');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { recordLinkV2 } = require('utilities/tagging');
// @constants
const { BANK_PHONE_NUMBER_CLIENTS_ONLY_1,
        CARD_MODIFY_LIMIT_REJECTED_MESSAGE,
        CARD_MODIFY_LIMIT_REJECTED_MESSAGE_ASNEF,
        CARD_MODIFY_LIMIT_OPERATION_ERROR_MESSAGE,
        EURO_TEXT } = require('constants/index');
const { getFormattedString } = require('utilities/currencyHelper');

const ModifyLimitErrorStep = props => {
    const { immCard, immCardModifyLimit, url, buttonText, immHireCreditLimit, getCustomTags, pageName } = props;
    const cardAlias = immCard.getIn(['alias', 'current']);
    const operationStatus = immCardModifyLimit.get('operationStatus');
    const creditLimit = immHireCreditLimit.get('creditLimit');
    const typeCode = immCard.getIn(['product', 'type']);
    const subtypeCode = immCard.getIn(['product', 'subtype']);
    let iconBlock;
    let message;
    let serviceErrorMessage;
    let titleSubkey;
 
const newLimit = {
    amount: creditLimit,
    currency: EURO_TEXT
};

useEffect(() => {
    if (getCustomTags) {
        const productType = `${typeCode}.${subtypeCode}`;
        const errorMessage = immCardModifyLimit.get('operationErrorMessage');
        const tag = getCustomTags({ pageName, creditLimit, productType, errorMessage }).onProcessSuccess;
        recordLinkV2(tag);
    }
}, []);

const formattedNewLimit = getFormattedString({
    amount: newLimit.amount,
    currency: newLimit.currency,
    decimalsLength: 0
});
    if (operationStatus === CARD_MODIFY_LIMIT_REJECTED_MESSAGE) {
        titleSubkey = 'rejectedTitle';
        message = <FormattedText value="cardModifyLimitErrorStep-rejectedMessage" />
        iconBlock = (
            <div className="card-modify-limit-error__icons-block">
                <i className="card-modify-limit-error__icon icon-s-llamar"/>
                <p className="card-modify-limit-error__phone-number">{BANK_PHONE_NUMBER_CLIENTS_ONLY_1}</p>
                <i className="card-modify-limit-error__icon  card-modify-limit-error__icon--right-icon icon-s-llamar"/>
                <p className="card-modify-limit-error__phone-number">
                    <FormattedText value="cardModifyLimitErrorStep-phoneNumberClients" />
                </p>
            </div>
        );
    }else if (operationStatus === CARD_MODIFY_LIMIT_REJECTED_MESSAGE_ASNEF) {
          titleSubkey = 'cardModifyLimitErrorStep-titleErrorAsnef';
         message = (
            <div>
                <div className="hire-card-via-t-error__text hire-card-via-t-error__text--margin-bottom">
                     <FormattedText
                            value="contractsView-asnefErrorText2"
                            className="contract-asnef-error__text"
                            injectedStrings={[formattedNewLimit]}
                        />
                </div>
            </div>
        );
    } 
    else {
        const isPendingError = immCardModifyLimit.get('errorCode') === '410065'; // error different that there's already a card registration request being processed
        titleSubkey = 'errorTitle';

        if (!isPendingError) {
            message = <FormattedText value="cardModifyLimitErrorStep-errorMessage" />
        }

        if (operationStatus === CARD_MODIFY_LIMIT_OPERATION_ERROR_MESSAGE) {
            const serviceErrorClass = classNames({
                'card-modify-limit-error__service-error': !isPendingError
            });

            serviceErrorMessage = (
                <div className={serviceErrorClass}>
                    {immCardModifyLimit.get('operationErrorMessage')}
                </div>
            );
        }
    }

    const title = formatText(`cardModifyLimitErrorStep-${titleSubkey}`);

    const goBackButton = {
        label: buttonText || formatText('cards-backToCard', [cardAlias]).toUpperCase(),
        url: url
    };
    const handleClickMainButton = () => {
        if (getCustomTags) {
            const tag = getCustomTags().onClickButtonSuccessScreen;
            recordLinkV2(tag);
        }
    };

    return (
        <div className="col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8">
            <WizardError
                errorMessage={title}
                mainButton={goBackButton}
                onMainButtonClick={handleClickMainButton}
                >
                <section className="row no-gutter">
                    <div className="col-xs-6 col-md-5">
                        <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                    </div>
                    <div className="col-xs-6 col-md-7">
                        {message}
                        {iconBlock}
                        {serviceErrorMessage}
                    </div>
                </section>
            </WizardError>
        </div>
    );
};

ModifyLimitErrorStep.propTypes = {
    immCard: PropTypes.object,
    immCardModifyLimit: PropTypes.object,
    url: PropTypes.string,
    buttonText: PropTypes.string
};

module.exports = ModifyLimitErrorStep;